import {createContext, ReactNode} from 'react';
import {Participant} from '@chekin/core';
import {OnboardingState} from '../store/useOnboardingStore';
import {StatusModalStates} from '@chekin/shared';

type CreateGuestsArgs = {
  customLeaderGuestId?: string;
  customParticipants?: Participant[];
  guestsData?: OnboardingState['guestsData'];
};

type GuestCreationContextType = {
  createGuests: (data?: CreateGuestsArgs) => Promise<void>;
  isProcessing: boolean;
  isModalOpen: boolean;
  guestRegistrationStatus: StatusModalStates;
  successSubtitle: ReactNode;
  errorMessage: string;
  errorMessages: string[];
  closeModalAndReset: () => void;
};

const GuestCreationContext = createContext<GuestCreationContextType | undefined>(
  undefined,
);

export {GuestCreationContext};
